angular
    .module('app')
    .component('gamesEdit', {
        templateUrl: '/templates/pages/games/gamesEdit/gamesEdit.html',
        controller: 'GamesEditController',
        controllerAs: 'vm',
    });